<div class="list-upcoming-mobile" #domContainer>
    <app-mobile-feed-page-template
        [count-of-pages]="countOfPages"
        [loaded-pages]="loadedPages"
        [is-loading]="isLoading"
        [root-url]="'home/history/list-upcoming'"
        [view-page]="viewPage"
        [pages]="this.rnumbPages"
        [is-feed-empty]="rnumbPages.length === 0"
        [feed-empty-text]="'Посещения не найдены'"
        [no-more-content-text]="'Посещений больше нет.'"
        *ngIf="!isLoading; else pageLoader"
    >
        <section
            page
            class="services-mobile__page"
            *ngFor="let group of groupedItems; let pageIndex = index"
        >
            <div
                class="actions-title"
                *ngIf="group.title && group.title.length"
            >
                {{ group.title }}
            </div>
            <ng-container
                *ngTemplateOutlet="talon; context: { $implicit: group }"
            ></ng-container>
        </section>
    </app-mobile-feed-page-template>
</div>

<div class="list-upcoming-desktop">
    <div class="cls-not-rec" *ngIf="!filteredRnumbList.length">
        Нет посещений
    </div>
    <div class="wrapper">
        <!-- Show Title for Each Group -->

        <section
            *ngFor="let group of groupedItems"
            class="services-mobile__page"
        >
            <div
                class="actions-title"
                *ngIf="group.title && group.title.length"
            >
                {{ group.title }}
            </div>
            <div class="list-upcoming__talons">
                <!-- Render Talons in This Group -->
                <ng-container
                    *ngTemplateOutlet="talon; context: { $implicit: group }"
                ></ng-container>

                <div *ngIf="loadingRnumbList" class="loading">
                    <loader type="page"></loader>
                </div>

                <!-- Grouped Items Loop -->
            </div>
        </section>
    </div>
</div>

<ng-template #talon let-group>
    <section
        class="talon"
        *ngFor="let rec of group.items; let i = index"
        (click)="openTalon(rec)"
    >
        <div class="talon__info">
            <div class="talon__header">
                <div class="talon__date-top">
                    <span class="date-align">{{
                        getNameDay(rec.beginDate)
                    }}</span>
                    <span class="date-align">{{ getDate(rec.beginDate) }}</span>
                </div>
            </div>

            <div class="talon__body">
                <div class="talon__time">{{ getTime(rec.beginDate) }}</div>
                <div class="talon__spec spec-align">{{ rec.spec }}</div>
                <div class="telemed-placeholder"></div>

                <div class="talon__bottom">
                    <div class="talon__fio">
                        {{ rec.lastname }} {{ rec.firstname }}
                        {{ rec.secondname }}
                    </div>
                    <div class="location" *ngIf="rec.addr">
                        <div
                            class="talon__address"
                            *ngIf="rec.addr; else emptyAddress"
                        >
                            {{ rec.addr }}
                        </div>
                        <ng-template #emptyAddress>
                            <div class="talon__address talon__address--empty">
                                &nbsp;<mat-icon svgIcon="location"></mat-icon>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div
                class="cls-div-telemed"
                *ngIf="!isMobile && rec.is_telemed"
                [ngClass]="{
                    'telemed-only':
                        rec.is_upload_files !== 1 && !rec.form_result_id
                }"
            >
                <ng-container
                    *ngIf="
                        rec.url_telemed;
                        then showIconTelemed;
                        else showIconNotPayTelemed
                    "
                ></ng-container>
            </div>
        </div>
        <div
            class="cls-div-telemed--mob"
            *ngIf="rec.is_telemed && isMobile"
            [ngClass]="{
                'telemed-only': rec.is_upload_files !== 1 && !rec.form_result_id
            }"
        >
            <ng-container
                *ngIf="
                    rec.url_telemed;
                    then showIconTelemed;
                    else showIconNotPayTelemed
                "
            ></ng-container>
        </div>
        <!-- *ngIf="isMobile" -->
        <div class="talon__buttons-container">
            <button
                class="fill-questionnaire-btn"
                (click)="onVisitProtocolClick(rec, $event)"
                *ngIf="rec.form_result_id && rec.is_exists === 0"
            >
                <img
                    src="./assets/img/svg/anketa-empty.svg"
                    alt="anketa-empty"
                />
                <span class="btn__text"> Заполните анкету</span>
            </button>
            <!-- isMobile &&  -->
            <button
                class="fill-anketa-btn"
                [class.attached]="rec.is_file_attached === 1"
                (click)="stopPropagation($event)"
                *ngIf="rec.is_upload_files === 1"
            >
                <svg
                    class="icon--upload"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.1222 0.000286943C15.2931 0.0151886 16.5032 0.610216 17.7287 1.77371C20.1987 4.11856 20.7118 7.55204 18.9838 9.4671L10.9692 18.3438C10.6053 18.7469 10.0081 18.7544 9.63554 18.3606C9.26295 17.9668 9.25597 17.3207 9.61995 16.9176L17.6341 8.0414C17.6341 8.04148 17.6342 8.04133 17.6341 8.0414C18.3088 7.29335 18.5025 5.22342 16.4847 3.30777C15.4662 2.34092 14.6725 2.04831 14.1001 2.04102C13.545 2.03396 13.0385 2.29319 12.5723 2.8098L2.15368 14.3494C1.99138 14.529 1.85192 14.8925 1.89329 15.407C1.93344 15.9063 2.14253 16.4613 2.55446 16.9178C3.09892 17.5212 3.56086 17.8256 3.88595 17.9238C4.14918 18.0033 4.28093 17.949 4.411 17.805L4.41791 17.7974L14.03 7.59484C14.0397 7.58266 14.0668 7.54405 14.0946 7.47389C14.1245 7.39868 14.1458 7.31028 14.1524 7.22043C14.165 7.04678 14.1237 6.91133 14.0271 6.8044C13.9334 6.70059 13.8247 6.66326 13.688 6.67554C13.6146 6.68213 13.5412 6.70371 13.478 6.73453C13.4121 6.76666 13.3796 6.79775 13.3743 6.80369L13.3736 6.80439L6.1608 14.7932C5.79682 15.1963 5.1997 15.2039 4.82711 14.8101C4.45451 14.4162 4.44752 13.7702 4.81151 13.367L12.0237 5.37895C12.0239 5.37872 12.0241 5.37848 12.0243 5.37825C12.3985 4.96341 12.9584 4.69317 13.5319 4.64166C14.1363 4.58737 14.829 4.77194 15.3764 5.37826C15.921 5.98143 16.08 6.73363 16.0328 7.38106C15.9877 7.99906 15.7501 8.60965 15.3778 9.0228L15.3705 9.03092L5.75218 19.2401C5.08137 19.9766 4.21439 20.1419 3.37877 19.8895C2.60181 19.6549 1.86181 19.0717 1.20479 18.3436C0.48365 17.5444 0.0914902 16.546 0.014131 15.5839C-0.0619904 14.6372 0.164929 13.6312 0.804374 12.9232M0.804374 12.9232L11.2226 1.38403C11.2226 1.38409 11.2227 1.38397 11.2226 1.38403C11.9579 0.569286 12.9341 -0.0148349 14.1222 0.000286943"
                        [attr.fill]="
                            rec.is_file_attached === 1
                                ? 'currentColor'
                                : 'currentColor'
                        "
                    />
                </svg>
                <input
                    type="file"
                    multiple
                    id="{{ 'upload_' + i }}"
                    name="files"
                    class="hidden-file-input"
                    (change)="onChangeInputUpload($event, rec)"
                />
                <!-- [disabled]="rec.is_file_attached === 1" -->
                <span class="btn__text">
                    {{
                        rec.is_file_attached === 1
                            ? "Файлы прикреплены"
                            : "Прикрепите файлы"
                    }}
                </span>
            </button>
        </div>
        <!-- Шаблоны для телемедицины -->
        <ng-template #tipContentPay>
            <div
                class="talon-content modal-teleIn-myRecMobile container-fluid talon-m"
            >
                <div class="modal__top">
                    <div
                        class="close__btn"
                        *ngIf="!isMobile"
                        (click)="JoinAndClose()"
                    >
                        <img src="./assets/img/svg/cross.svg" alt="close" />
                    </div>
                </div>
                <div class="cls-blok-res-rec cls-cansel-text addToTele">
                    <p class="title">
                        <b>Подключиться к Телеконференции?</b>
                    </p>
                    <div class="cls-cansel-btn">
                        <button
                            class="telemed__btn"
                            (click)="goToTelemed(rec, $event)"
                        >
                            {{ isMobile ? "Да" : "Подключиться" }}
                        </button>
                        <button
                            class="telemed__btn-return"
                            (click)="JoinAndClose()"
                        >
                            {{ isMobile ? "Нет" : " Вернуться к номерку" }}
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #tipContentNotPay let-greeting="greeting">
            <div>Ссылка на Телеконференцию появится только после оплаты.</div>
        </ng-template>

        <ng-template #showIconTelemed>
            <img
                src="./assets/img/svg/telem-icon.svg"
                class="telem-icon"
                (click)="open($event, tipContentPay)"
            />
        </ng-template>

        <ng-template #showIconNotPayTelemed>
            <div
                class="telemed_tooltip"
                data-tooltip="Ссылка на Телеконференцию появится только после оплаты."
            >
                <img
                    src="./assets/img/svg/telem-icon.svg"
                    (click)="stopPropagation($event)"
                    class="telem-icon"
                />
            </div>
        </ng-template>
    </section>
</ng-template>

<ng-template #pageLoader>
    <div class="page-loader">
        <loader type="page" [isFullscreen]="true"></loader>
    </div>
</ng-template>
